import { CaseView } from "components/QualityAssurance";
import { connect } from "react-redux";
import { generatePDF } from "actions/homeowner/pdf";
import {
    getNextCase,
    returnCase,
    sendToManager,
    completeCase,
    setQAReady,
    setQAPaused,
    setQAStarted,
    setQAValidationErrors,
    setQASummaryViewEnabled,
    setQAShowRejectDialog,
    setQAShowSendManagerDialog,
    setQAShowCompletedCaseDialog,
    setQASwitchCaseDialog,
    setQACompletingCase,
    setQARejectingCase,
    setQAEscalatingCase,
    setQASaveDataFunction,
    getCaseForms,
    getCaseAlerts,
    getCaseInfo,
    getCaseSketch,
    sendToAgent,
    addReviewCaseTimeLog,
    setPhoenixRctCommitStatus,
    setQATimeSpent,
    resetQACase,
    setQATimerInfo,
} from "actions/qualityAssurance/";
import { formStatusChange, validateForms } from "actions/homeowner/caseforms";
import { getActiveClock } from "actions/account";
import responseHandler from "responseHandler";
import { getAllCaseFormsRedux } from "requests/homeowner/ho";
import { getQuickLists, getQuickListCount } from "actions/homeowner/quickList";
import { userHasRight } from "selectors/rights";
import { QA_DASHBOARD_VIEW } from "typeConstants/rights";

const mapStateToProps = (state) => {
    return {
        token: state.user.profile.token,
        qaCase: state.qualityAssurance.qaCase,
        caseForms: state.caseForms.caseFormsList,
        allCaseFormsList: state.caseForms.allCaseFormsList,
        pnxValidation: state.caseForms.pnxValidation,
        requestSuccessful: state.qualityAssurance.requestSuccessful,
        profile: state.user.profile,
        qaReady: state.qualityAssurance.qaVariables.qaReady,
        qaStarted: state.qualityAssurance.qaVariables.qaStarted,
        qaPaused: state.qualityAssurance.qaVariables.qaPaused,
        validationErrors: state.qualityAssurance.qaVariables.validationErrors,
        summaryViewEnabled: state.qualityAssurance.qaVariables.summaryViewEnabled,
        showRejectDialog: state.qualityAssurance.qaVariables.showRejectDialog,
        showSwitchCaseDialog: state.qualityAssurance.qaVariables.showSwitchCaseDialog,
        switchCaseDialogControlNum: state.qualityAssurance.qaVariables.switchCaseDialogControlNum,
        showSendToManagerDialog: state.qualityAssurance.qaVariables.showSendToManagerDialog,
        showCompleteCaseDialog: state.qualityAssurance.qaVariables.showCompleteCaseDialog,
        completingCase: state.qualityAssurance.qaVariables.completingCase,
        rejectingCase: state.qualityAssurance.qaVariables.rejectingCase,
        escalatingCase: state.qualityAssurance.qaVariables.escalatingCase,
        keepGettingCases: state.qualityAssurance.qaVariables.keepGettingCases,
        qaSaveDataFunction: state.qualityAssurance.qaVariables.qaSaveDataFunction,
        publicPropertyRecord: state.caseForms.publicPropertyRecord,
        isFetchingPublicPropertyRecord: state.caseForms.isFetchingPublicPropertyRecord,
        timeSpent: state.qualityAssurance.qaVariables.timeSpent,
        activeClock: state.user.activeClock,
        rights: state.user.profile.rights,
        willLogOut: state.user.willLogOut,
        caseAuditRequired: state.qualityAssurance.qaCase?.caseAuditRequired,
        caseAuditCompleted: state.qualityAssurance.qaCase?.caseAuditCompleted,
        caseAuditFeedbackCompleted: state.qualityAssurance.qaCase?.caseAuditFeedbackCompleted,       
        quickLists: state.quickList.quickLists,
        qaTimerId: state.qualityAssurance.timerId,
        qaTimerPingIntervalSeconds: state.qualityAssurance.timerPingIntervalSeconds,
        canViewQaDashboard: userHasRight(QA_DASHBOARD_VIEW)(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    getNextCase(payload, callback) {
        dispatch(getNextCase(payload, callback));
    },
    returnCase(payload, callback) {
        dispatch(returnCase(payload, callback));
    },
    sendToManager(payload, callback) {
        dispatch(sendToManager(payload, callback));
    },
    completeCase(payload, callback) {
        dispatch(completeCase(payload, callback));
    },
    generatePDF(controlNumber) {
        dispatch(generatePDF(controlNumber));
    },
    setQAReady(isQAReady) {
        dispatch(setQAReady(isQAReady));
    },
    setQAPaused(isQAPaused) {
        dispatch(setQAPaused(isQAPaused));
    },
    setQAStarted(isQAStarted) {
        dispatch(setQAStarted(isQAStarted));
    },
    setQAValidationErrors(qaValidationErrors) {
        dispatch(setQAValidationErrors(qaValidationErrors));
    },
    setQASummaryViewEnabled(isQASummaryViewEnabled) {
        dispatch(setQASummaryViewEnabled(isQASummaryViewEnabled));
    },
    setQAShowRejectDialog(shouldShowRejectDialog) {
        dispatch(setQAShowRejectDialog(shouldShowRejectDialog));
    },
    setQAShowSendManagerDialog(shouldShowManagerDialog) {
        dispatch(setQAShowSendManagerDialog(shouldShowManagerDialog));
    },
    setQAShowCompletedCaseDialog(shouldShowCompletedCaseDialog) {
        dispatch(setQAShowCompletedCaseDialog(shouldShowCompletedCaseDialog));
    },
    setQASwitchCaseDialog(shouldShowDialog) {
        dispatch(setQASwitchCaseDialog(shouldShowDialog));
    },
    setQACompletingCase(isCompletingCase) {
        dispatch(setQACompletingCase(isCompletingCase));
    },
    setQARejectingCase(isRejectingCase) {
        dispatch(setQARejectingCase(isRejectingCase));
    },
    setQAEscalatingCase(isEscalatingCase) {
        dispatch(setQAEscalatingCase(isEscalatingCase));
    },
    setQASaveDataFunction(saveDataFunction) {
        dispatch(setQASaveDataFunction(saveDataFunction));
    },
    getCaseInfo(payload, callback) {
        dispatch(getCaseInfo(payload, callback));
    },
    getCaseForms(id) {
        dispatch(getCaseForms(id));
    },
    getCaseSketch(payload, callback) {
        dispatch(getCaseSketch(payload, callback));
    },
    getCaseAlerts() {
        dispatch(getCaseAlerts());
    },
    getActiveClock(timeZoneOffset) {
        dispatch(getActiveClock(timeZoneOffset));
    },
    addReviewCaseTimeLog(dto) {
        dispatch(addReviewCaseTimeLog(dto, false));
    },
    formStatusChange(formName, status, messages) {
        dispatch(formStatusChange(formName, status, messages));
    },
    validateForms(controlIdNumber, formId = null, callback = null) {
        dispatch(validateForms(controlIdNumber, formId, callback));
    },
    sendToAgent(payload, callback) {
        dispatch(sendToAgent(payload, callback));
    },
    makeToast(text, type) {
        responseHandler.customToast(text, type, dispatch);
    },
    setPhoenixRctCommitStatus(status) {
        dispatch(setPhoenixRctCommitStatus(status));
    },
    setQATimeSpent(qaTimeSpent) {
        dispatch(setQATimeSpent(qaTimeSpent));
    },
    getAllCaseFormsRedux(controlNumber) {
        dispatch(getAllCaseFormsRedux(controlNumber));
    },
    resetQACase(callBack = null) {
        dispatch(resetQACase(callBack));
    },
    setQATimerInfo(timerId, timerPingIntervalSeconds) {
        dispatch(setQATimerInfo(timerId, timerPingIntervalSeconds));
    }, 
    getQuickLists(refreshList) {
        dispatch(getQuickLists(refreshList));
    },
    getQuickListCount(quickList) {
        dispatch(getQuickListCount(quickList));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseView);
